import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material';
import { OnboardingStepProps } from './OnboardingStep1Basics';

export function OnboardingStep4Policies({ form, errors, setField }: OnboardingStepProps) {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
        {t('onboarding.step4.acknowledgementTitle')}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 2, maxHeight: 280, overflowY: 'auto' }}
      >
        {t('onboarding.step4.acknowledgementBody')}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={form.policies_acknowledged}
            onChange={(e) => setField('policies_acknowledged', e.target.checked)}
          />
        }
        label={t('onboarding.step4.agreePolicies')}
      />
      {errors.policies_acknowledged ? (
        <FormHelperText error sx={{ mx: 0 }}>
          {errors.policies_acknowledged}
        </FormHelperText>
      ) : null}
    </>
  );
}
